import React from "react";
import PropTypes from "prop-types";
import { Grid, Button } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { clearDatabase } from "../../api/settingsApi";
import CustomButton from "components/CustomButton";

const ClearDatabase = ({ onSnackBarOpen, onLoading, selectedStore, userId }) => {
  const handleClearDatabase = async () => {
    if (!selectedStore) {
      onSnackBarOpen("warning", "Please select a store before clearing the database.");
      return;
    }
    onLoading(true);
    try {
      await clearDatabase(selectedStore, userId);
      onSnackBarOpen("success", "Database cleared successfully!");
    } catch (error) {
      console.error("Error:", error);
      onSnackBarOpen("error", "Failed to clear database.");
    } finally {
      onLoading(false);
    }
  };

  return (
    <Grid item xs={6}>
      <MDTypography variant="h6" gutterBottom>
        Clear Database
      </MDTypography>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <CustomButton
          variant="contained"
          color="error"
          size="medium"
          startIcon={<DeleteIcon />}
          onClick={handleClearDatabase}
          sx={{ mt: 2 }}
        >
          Clear Database
        </CustomButton>
      </MDBox>
    </Grid>
  );
};

ClearDatabase.propTypes = {
  onSnackBarOpen: PropTypes.func.isRequired,
  onLoading: PropTypes.func.isRequired,
  selectedStore: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ClearDatabase;
